import { render, staticRenderFns } from "./ThemAlloc.vue?vue&type=template&id=fdad0504&scoped=true&"
import script from "./ThemAlloc.vue?vue&type=script&lang=js&"
export * from "./ThemAlloc.vue?vue&type=script&lang=js&"
import style0 from "./ThemAlloc.vue?vue&type=style&index=0&id=fdad0504&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdad0504",
  null
  
)

export default component.exports